var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksUserPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.999 52.5V47.5C39.999 44.8478 38.9455 42.3043 37.0701 40.4289C35.1947 38.5536 32.6512 37.5 29.999 37.5H12.499C9.84686 37.5 7.30332 38.5536 5.42796 40.4289C3.55259 42.3043 2.49902 44.8478 2.49902 47.5V52.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.249 27.5C26.7719 27.5 31.249 23.0228 31.249 17.5C31.249 11.9772 26.7719 7.5 21.249 7.5C15.7262 7.5 11.249 11.9772 11.249 17.5C11.249 23.0228 15.7262 27.5 21.249 27.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.999 20V35",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.499 27.5H42.499",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksUserPlus);
export default __webpack_public_path__ + "static/media/how-it-works-user-plus.f9f4049ae3683d622ce00cb08b6ce527.svg";
export { ForwardRef as ReactComponent };